module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qskel6-3bce4f27a0b8024a3771d952e7691823.jpg";